import { useState, useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import { getInputParams, csvUrl } from '../CustomUtils.js'
import { BILLED_HOURS_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ReportHeading from '../ReportHeading.js'
import ParameterValues from '../ParameterValues.js'
import LargeRowHandler from '../LargeRowHandler.js'
import '../Custom.css'
import ReportGrid from '../ReportGrid.js'
import { handleGraphQLErrors } from '../../../utils'

const BILLED_HOURS_REPORT = gql(BILLED_HOURS_REPORT_QUERY)

export default function BilledHoursReport() {
  console.log('BilledHoursReport rendered')

  let location = useLocation()
  const inputs = getInputParams(location)
  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])
  const [showSpinner, setShowSpinner] = useState(false)

  useEffect(() => {
    async function fetchFormData() {
      try {
        setShowSpinner(true)
        const inputs = getInputParams(location)
        const { data, errors } = await window.apolloClient.query({ query: BILLED_HOURS_REPORT, variables: { inputs: inputs } })
        if (data.billedHoursReport) {
          console.log(data.billedHoursReport)
          setResults(data.billedHoursReport)
        } 
        if (errors) {
          setGraphQLErrors(errors)
        }
      } catch (err) {
        handleGraphQLErrors(err, setGraphQLErrors)
      } finally {
        setShowSpinner(false)
      }
    }
    fetchFormData()
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } 
  if (showSpinner) {
    return <Spinner />
  }
  if (results) {
    const numberFormatter = new Intl.NumberFormat()
    const hoursColumn  = inputs.reportType === 'S' ? 4 : 5
    const columnFormatter = [{ columnNumber: hoursColumn, formatter: numberFormatter.format, align: 'right' }]
    let title = ''
    if (inputs.reportType === 'S') {
      title = 'Billed Hours Summary Report'
    } else {
      title = 'Billed Hours Detail Report'
    }
    const url = 'ITProjects/billedHoursReport/billedHoursReport'
    return (
      <div className="custom-scroll">
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl(url, location)} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{ backgroundColor: 'white', width: 'auto', margin: 'auto' }} >
          <ReportHeading title={title} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            <ReportGrid results={results} columnFormatters={columnFormatter} />
          </tbody>
        </Table>
      </div>
    )
  }
}